import CurrencyDeterminer from "@/module/Form/Currency/CurrencyDeterminer";

export default class AlwaysCurrencyDeterminer implements CurrencyDeterminer {
  private readonly currency: string;

  constructor(currency: string) {
    this.currency = currency;
  }

  determinate(): string {
    return this.currency;
  }
}
